import { Component, DestroyRef, inject, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgClass } from '@angular/common';
import { ModalComponent } from '../../../shared/components/modal/modal';
import { CategoryService } from '../../../core/services/category.service';
import { ToastService } from '../../../core/services/toast.service';
import { apiErrorMessage } from '../../../shared/utils/api-error';

type ClassificationType = 'Situation' | 'Response';

@Component({
  selector: 'app-create-category-modal',
  imports: [ModalComponent, NgClass],
  templateUrl: './create-category-modal.html',
})
export class CreateCategoryModalComponent {
  closed = output<void>();
  saved = output<void>();

  private categoryService = inject(CategoryService);
  private toastService = inject(ToastService);
  private destroyRef = inject(DestroyRef);

  protected categoryName = signal('');
  protected classificationType = signal<ClassificationType>('Situation');
  protected showErrors = signal(false);
  protected submitting = signal(false);

  protected onSubmit(): void {
    this.showErrors.set(true);
    if (!this.categoryName().trim()) return;

    this.submitting.set(true);
    const payload = { name: this.categoryName().trim() };
    const request$ =
      this.classificationType() === 'Situation'
        ? this.categoryService.createSituationCategory(payload)
        : this.categoryService.createResponseCategory(payload);

    request$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        this.toastService.show('Category created successfully');
        this.saved.emit();
      },
      error: (err) => {
        this.toastService.show(apiErrorMessage(err, 'Failed to create category'), 'error');
        this.submitting.set(false);
      },
    });
  }
}
